










import {Vue, Component, Prop} from "vue-property-decorator";

@Component( {
    components: {}
})
export default class ControlWrapper extends Vue {

    @Prop({ default: 'transparent'}) modificationName: string;
    @Prop() error: boolean;
    @Prop({ default: false }) disabled: boolean;

    get className() {
        return {
            [`borderless-control control-wrapper-borderless__control_${this.modificationName}`]: true,
            ['borderless-control_error']: this.error,
            ['borderless-control_disabled']: this.disabled
        }
    }

}
